import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class InputStackItem extends EquatableKeyStackItem {
    asInput() {
        return this.value;
    }
}

//# sourceMappingURL=InputStackItem.js.map
